import { useState, useEffect, useCallback } from "react";
import ApiService from "./ApiService";
import { socket } from "src/socket";

/**
 * Хук для получения заявки крипто-авто-смены
 * @param {number} orderId - ID заявки
 * @returns {Object} Объект с данными заявки, состоянием загрузки и ошибкой
 */
export const useOrder = (orderId) => {
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchOrder = useCallback(async (id) => {
    if (!id) {
      setError("ID заявки не указан");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await ApiService.getOrder(id);

      // Преобразуем даты из строк в объекты Date
      const orderData = {
        ...response.data,
        created_at: new Date(response.data.created_at),
        updated_at: new Date(response.data.updated_at),
      };

      setOrder(orderData);
    } catch (err) {
      console.error("Ошибка при получении заявки:", err);
      setError(
        err.response?.data?.message ||
          err.message ||
          "Произошла ошибка при получении заявки"
      );
    } finally {
      setLoading(false);
    }
  }, []);

  const refetch = useCallback(() => {
    if (orderId) {
      fetchOrder(orderId);
    }
  }, [orderId, fetchOrder]);

  // WebSocket подключение для отслеживания обновлений
  useEffect(() => {
    if (!orderId) return;

    const handleOrderUpdate = (updatedOrderId) => {
      console.log(
        "Получено обновление заявки крипто-авто-смены, ID:",
        updatedOrderId
      );

      // Проверяем, что обновление относится к текущей заявке
      if (updatedOrderId === orderId || updatedOrderId === orderId.toString()) {
        console.log("ID совпадает, перезагружаем заявку:", orderId);

        // Перезагружаем заявку через API
        fetchOrder(orderId);
      }
    };

    // Подписываемся на событие обновления заявок крипто-авто-смены
    socket.on("auto_change_ord_upd", handleOrderUpdate);

    // Очистка при размонтировании
    return () => {
      socket.off("auto_change_ord_upd", handleOrderUpdate);
    };
  }, [orderId, fetchOrder]);

  const emitOrder = (orderId, data = {}) => {
    return ApiService.emitOrder(orderId, data);
  };

  useEffect(() => {
    if (orderId) {
      fetchOrder(orderId);
    }
  }, [orderId, fetchOrder]);

  return {
    order,
    loading,
    error,
    refetch,
    emitOrder,
  };
};
